import CompanyInfo from "./Components/CompanyInfo";

export default CompanyInfo;
